export const GetNumberOfDays = (startDate, endDate) => {
    let start = new Date(startDate);
    let end = new Date(endDate);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return (end.getTime() - start.getTime()) / (1000 * 3600 * 24) + 1;
}
